import React, { Fragment, useEffect, useState } from 'react';

//components
import Table from '../common/table/Table';
import Paginator from '../common/paginator/Paginator';

//hooks
import useBrokerAssisterTableData from '../../hooks/useBrokerAssisterTableData';

//constants
import { faCog } from '@fortawesome/free-solid-svg-icons';


const BrokerAndAssisterScreenPopTable = props => {

    const {
        data,
        paginationData,
        entityType,
        sortByHandler,
        sortBy
    } = props;


    const paginatorData = {
        ...paginationData,
        first: true,        
        isBlocked: false,
        isEmpty: false
    };

    const { columns } = useBrokerAssisterTableData({ entityType, sortByHandler, sortBy });

    return(
        <Fragment>
            {
                data &&
                <div className='grid-row width-full'>
                    <Table columns={columns} data={data} isFullWidth={true} />
                    <div className='pagination-container__screenpop'>
                        <Paginator
                            {...{
                                ...paginatorData
                            }}
                        />
                    </div>  
                </div>
            }
        </Fragment>  
    );
};


export default BrokerAndAssisterScreenPopTable;